export default __webpack_public_path__ + "static/media/super-rare.2bd08e9a.svg";